import { render, staticRenderFns } from "./AgendaPartials.vue?vue&type=template&id=bb75d750"
import script from "./AgendaPartials.vue?vue&type=script&lang=js"
export * from "./AgendaPartials.vue?vue&type=script&lang=js"
import style0 from "./AgendaPartials.vue?vue&type=style&index=0&id=bb75d750&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports